import React, { useState } from "react";
import Modal from "../../../components/modal";
import LoadingButton from "../../../components/loadingButton";
import api from "../../../services/api";
import { toast } from "react-hot-toast";

export function CreateTrainingModal({ onDone }) {
  const [isLoading, setIsLoading] = useState(false);
  const [newTraining, setNewTraining] = useState({
    title: "",
    description: "",
    chapter_order: [], // Initialize empty chapter order array
  });
  const [isOpen, setIsOpen] = useState(false);

  const handleCreateTraining = async () => {
    try {
      if (!newTraining.title.trim()) return toast.error("Please enter a training name");

      const { data, ok } = await api.post("/training", {
        ...newTraining,
        chapter_order: ["Chapter 1"], // Initialize with a default first chapter
      });
      if (!ok) throw new Error("Failed to create training");

      onDone();
      toast.success("Training created successfully!");
    } catch (error) {
      toast.error("Failed to create training");
      onDone();
    }
  };

  const handleSubmit = async () => {
    if (!newTraining.title.trim()) return;
    if (isLoading) return;

    try {
      setIsLoading(true);
      await handleCreateTraining();
      setIsOpen(false);
      setNewTraining({
        title: "",
        description: "",
        chapter_order: [],
      });
    } catch (error) {
      console.error("Failed to create training:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen)
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white px-4 py-2.5 rounded-xl text-sm font-medium shadow-sm hover:shadow-md transition-all duration-200">
        Create Training
      </button>
    );

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} className="max-w-xl w-full p-6">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">Create New Training</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Training Name</label>
            <input
              type="text"
              value={newTraining.title}
              onChange={(e) => setNewTraining({ ...newTraining, title: e.target.value })}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
              placeholder="Enter training name"
              disabled={isLoading}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (Optional)</label>
            <textarea
              value={newTraining.description}
              onChange={(e) => setNewTraining({ ...newTraining, description: e.target.value })}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
              rows="3"
              placeholder="Enter training description"
              disabled={isLoading}
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={() => setIsOpen(false)}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            Cancel
          </button>
          <LoadingButton
            onClick={handleSubmit}
            isLoading={isLoading}
            disabled={!newTraining.title.trim() || isLoading}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            Create Training
          </LoadingButton>
        </div>
      </div>
    </Modal>
  );
}
